// frontend/src/features/engine/tools/grbas/components/GRBASForm.jsx

import { useMemo, useState } from "react";

import {
  GRBAS_ATTRIBUTE_DEFINITIONS,
  GRBAS_SCALE_VALUES,
} from "../grbasConfig";

export default function GRBASForm({
  onSubmit,
  disabled = false,
  disabledMessage = "",
}) {
  const [values, setValues] = useState({});

  const isComplete = useMemo(
    () =>
      GRBAS_ATTRIBUTE_DEFINITIONS.every(
        ({ id }) => values[id] !== undefined
      ),
    [values]
  );
  const canSubmit = !disabled && isComplete;

  const handleSubmit = (event) => {
    event.preventDefault();

    if (canSubmit) {
      onSubmit(values);
    }
  };

  const handleSelect = (key, ordinal) => {
    if (disabled) {
      return;
    }

    setValues((current) => ({
      ...current,
      [key]: ordinal
    }));
  };

  return (
    <form
      className="activity-form"
      onSubmit={handleSubmit}
    >
      <div className="app-module-section">
        <h2>Rating form</h2>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 24
          }}
        >
          {GRBAS_ATTRIBUTE_DEFINITIONS.map(({ id, label }) => (
            <fieldset
              key={id}
              style={{
                border: "1px solid #ddd",
                borderRadius: 10,
                padding: "20px 24px 24px",
                margin: 0
              }}
            >
              <legend
                style={{
                  padding: "0 8px",
                  fontWeight: 600
                }}
              >
                {label}
              </legend>

              <div
                role="group"
                aria-label={label}
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(4, minmax(80px, 1fr))",
                  gap: 12,
                  marginTop: 8
                }}
              >
                {GRBAS_SCALE_VALUES.map(([ordinal, description]) => {
                  const isSelected = values[id] === ordinal;

                  return (
                    <button
                      key={ordinal}
                      type="button"
                      className={`app-btn app-btn-selectable${
                        isSelected ? " selected" : ""
                      }`}
                      aria-pressed={isSelected}
                      disabled={disabled}
                      onClick={() => handleSelect(id, ordinal)}
                      style={{
                        width: "100%",
                        minHeight: 56,
                        flexDirection: "column",
                        gap: 5
                      }}
                    >
                      <strong>{ordinal}</strong>

                      <span
                        style={{
                          fontSize: "0.78rem",
                          fontWeight: 500
                        }}
                      >
                        {description}
                      </span>
                    </button>
                  );
                })}
              </div>
            </fieldset>
          ))}
        </div>
      </div>

      {disabledMessage ? (
        <div
          className="warning-message"
          style={{ marginTop: 16 }}
        >
          {disabledMessage}
        </div>
      ) : !isComplete ? (
        <div
          className="warning-message"
          style={{ marginTop: 16 }}
        >
          Please complete all five GRBAS ratings before submitting.
        </div>
      ) : null}

      <div className="app-btn-container">
        <button
          type="submit"
          className="app-btn app-btn-primary"
          disabled={!canSubmit}
        >
          Submit ratings
        </button>
      </div>
    </form>
  );
}
